/**
 * Date field formatter
 */

import {useDateTime} from '@hconnect/tuc-processes/fields'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'
import moment from 'moment'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const useDateFormatter = (): FieldFormatter => {
  const {dateTime, defaultDateTime} = useDateTime()
  const dateState = useChangeableField({field: 'dateTime', fieldPart: 'date'})

  return (context) => {
    const {t} = context
    const requiresApproval = dateState.state === 'requireDispatchConfirmation'
    const hasChanges = dateState.isDirty

    // Format like DateFieldButton: "DD.MM.YYYY"
    const formatDate = (dt: unknown): string | null => {
      if (!dt || !Array.isArray(dt) || !dt[0]) return null
      return moment(dt[0]).format('DD.MM.YYYY')
    }

    const oldValue = formatDate(defaultDateTime)
    const newValue = formatDate(dateTime)

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
